import TopLayoutBlog from 'docs/src/modules/components/TopLayoutBlog';
import { docs } from './bringing-consistency-to-material-ui-customization-apis.md?muiMarkdown';

export default function Page() {
  return <TopLayoutBlog docs={docs} />;
}
